import React from 'react';
import { css } from '@emotion/react';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { Alert } from 'ALIASED-antd';

const AppointmentAlert = () => {
  const [alert, setAlert] = useSessionFormState('alert', null);

  if (!alert) return null;

  return (
    <Alert
      css={css({ marginBottom: '1rem' })}
      message={alert.message}
      type={alert.type}
      closable
      afterClose={() => setAlert(null)}
      showIcon
    />
  );
};

export default AppointmentAlert;
